<div class="loader-container">
  <img class="loading-gif" src="../assets/Coffeeloader.svg" alt="loading">
</div>
